import script from "./MomentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MomentModal.vue?vue&type=script&setup=true&lang=js"

import "./MomentModal.vue?vue&type=style&index=0&id=65dd46c1&scoped=true&lang=scss"
import "./MomentModal.vue?vue&type=style&index=1&id=65dd46c1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65dd46c1"]])

export default __exports__